var map = {
	"./claim.js": 20033,
	"./node.js": 98473,
	"./private.js": 17754,
	"./purchase.js": 23106,
	"./server.js": 43822,
	"./stake.js": 57847,
	"./stakeRecord.js": 98166,
	"./wallet.js": 44664
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 46453;